import { Box, Typography } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";
import AppButton from "../../components/app-button/AppButton";

function EmptyKOTState({ onRefresh, loading }) {
  return (
    <Box
      sx={{
        border: "1px dashed #e0e0e0",
        borderRadius: 2,
        p: 6,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: "#fafafa",
        minHeight: "300px",
        mt: 4,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          backgroundColor: "#f1f5f9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <Iconify icon="mdi:silverware-fork-knife" width={36} color="#64748b" />
      </Box>

      <Typography variant="h6" fontWeight="600" gutterBottom>
        No Active KOTs
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 360, mb: 3 }}
      >
        There are currently no kitchen orders waiting to be prepared. New KOTs
        will appear here automatically.
      </Typography>

      <AppButton
        variant="contained"
        startIcon={<Iconify icon="solar:refresh-bold-duotone" />}
        onClick={onRefresh}
        loading={loading}
        style={{
          background: "#e0a800",
        }}
      >
        Refresh
      </AppButton>
    </Box>
  );
}

export default EmptyKOTState;
